import axios from './axios';

async function analyzeTripActualsByGeoLocations(tripId: number) {
  const res = await axios.get(`/geoAnalyzer/trips/${tripId}/getActual`);
  return res.status === 200;
}

export const GeoAnalyzeService = { analyzeTripActualsByGeoLocations };
